import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import cx from 'classnames';

type Props = {
  src: string;
  alt: string;
  lazy?: boolean;
  animate?: boolean;
  className?: string;
  width?: string;
  height?: string;
};

export const Image = (props: Props) => {
  const { src, lazy, alt, animate, className, width = 'auto', height = 'auto', ...rest } = props;

  const [imageLoaded, setImageLoaded] = useState(false);
  const handleImgLoad = () => setImageLoaded(true);

  /**
   * We need to set a height and width else all images will be in the viewport once
   * the page loads and thus all loaded at once. When a lazy image is wrapped in a
   * div, we can omit the width and height so that it occupies 100% of it's parent
   */
  if (lazy) {
    return (
      <LazyImage
        alt={alt}
        src={src}
        width={width || '100%'}
        height={height || '100%'}
        className={cx(className, { animate, 'img-loaded': imageLoaded })}
        threshold={350}
        onLoad={handleImgLoad}
        {...rest}
      />
    );
  }

  return (
    <NormalImage
      src={src}
      alt={alt}
      className={cx(className, { animate, 'img-loaded': imageLoaded })}
      onLoad={handleImgLoad}
      {...rest}
    />
  );
};

const LazyImage = styled(LazyLoadImage)`
  &.animate {
    opacity: 0;
    transition: 1s opacity ease;
  }

  &.animate.img-loaded {
    opacity: 1;
  }
`;

const NormalImage = styled.img`
  &.animate {
    opacity: 0;
    transition: 1s opacity ease;
  }

  &.animate.img-loaded {
    opacity: 1;
  }
`;
